import React, { useContext, useMemo, useState } from 'react';

import { Draggable } from 'react-beautiful-dnd';

import { AssignContext } from '../../AssignProvider';

import AssignPackItems from './AssignPackItems';

import MinusIcon from 'Assets/icons/minus.svg';
import PlusIcon from 'Assets/icons/plus.svg';

export default function AssignPack({ pack, index }) {
    const [collapsed, setCollapsed] = useState(true);

    const { selectedVenue, filterDay, filterDays, formattedDate, formattedDates, selectedAmount, selectedDate, selectedSchedules } = useContext(AssignContext);

    const costPerPack = useMemo(() => pack.pack_children.reduce((total, item) => total + item.pivot.amount * item.price, 0), [pack]);

    if (pack.can_be_edited) {
        return (
            <Draggable
                draggableId={JSON.stringify({
                    packId: pack.id,
                    selectedVenue: selectedVenue,
                    filterDay: filterDay,
                    filterDays: filterDays,
                    formattedDate: formattedDate,
                    formattedDates: formattedDates,
                    selectedAmount: selectedAmount,
                    selectedDate: selectedDate,
                    selectedSchedules: selectedSchedules,
                })}
                index={index}
            >
                {(provided, snapshot) => {
                    return (
                        <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                            <AssignPackContent pack={pack} costPerPack={costPerPack} collapsed={collapsed} setCollapsed={setCollapsed} />
                        </div>
                    );
                }}
            </Draggable>
        );
    }

    return (
        <div>
            <AssignPackContent pack={pack} costPerPack={costPerPack} collapsed={collapsed} setCollapsed={setCollapsed} />
        </div>
    );
}

function AssignPackContent({ pack, costPerPack, collapsed, setCollapsed }) {
    return (
        <div className="tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white">
            <div className="tw-p-2.5 tw-space-y-4">
                <div className="tw-flex tw-gap-4 tw-text-sm tw-text-charcoal">
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{pack.name}</div>
                    </div>
                    <div className="tw-basis-full tw-shrink tw-grow">
                        <div>{costPerPack}</div>
                    </div>
                    <div className="tw-basis-9 tw-flex tw-items-center tw-justify-end tw-space-x-3">
                        <button className="table__icon-btn tw-text-white" onClick={() => setCollapsed((state) => !state)}>
                            {collapsed ? <PlusIcon className="tw-w-3.5 tw-h-3.5" /> : <MinusIcon className="tw-w-3.5 tw-h-3.5" />}
                        </button>
                    </div>
                </div>

                {!collapsed &&
                    (pack.pack_children.length ? (
                        <div className="inbud-table_wrapper">
                            <table className="inbud-table tw-table-fixed">
                                <thead>
                                    <tr>
                                        <th>{$t('Description')}</th>
                                        <th>{pack.pack_contractor ? $t('Rate Per Hour') : $t('Unit Price')}</th>
                                        <th>{$t('Qty Per Pack')}</th>
                                        <th>{pack.pack_contractor ? $t('Total Per Hour') : $t('Total Per Pack')}</th>
                                    </tr>
                                </thead>
                                {pack.id && <AssignPackItems packItems={pack.pack_children} />}
                            </table>
                        </div>
                    ) : (
                        <div className="tw-text-sm tw-text-charcoal-50">{$t('Pack has no items')}</div>
                    ))}
            </div>
        </div>
    );
}
